typeof UrlApi == 'undefine' && (UrlApi = 'https://my.ice-fx.com/api');
var theArray = {};
$('div.f-configuration-body div.row div.checkedcol table tbody tr[name] td.has--checkbox input[name]').click(function () {
    var boxes = $('div.f-configuration-body div.row div.checkedcol table tbody tr[name] td.has--checkbox input[name]');
    for (var i = 0; i < boxes.length; i++) {
        theArray[boxes[i].name] = boxes[i].checked;
    }
    hidecell(theArray);
});

$('div.f-configuration-body div.row div.checkedcol table tbody tr td.has--input input[name]').focusout(function () {
    var elem = $(this);
    changeInput(elem[0].value, elem[0].name);
    $('div.pamm-rates table.ratetable tr.filters input[name]').trigger('keyup');
});

$('div.pamm-rates table.ratetable tr.filters input[name]').on('keyup', function () {
    setTimeout(function () {
        if (!Object.keys(theArray).length == 0) hidecell(theArray);
    }, 700);
});

function hideCellsforSub() {
    //setTimeout(function () {
    if (!Object.keys(theArray).length == 0) hidecell(theArray);
    //}, 200);
}

function checkLoadPopup() {
    var elem = $('div.f-saved-configuration div.f-saved-configuration__item');
    elem.length == 0 ? $('#NoitemsAlert').show() : $('#NoitemsAlert').hide();
}

//function onloadConf() {
//    debugger;

//    var test = localStorage.length;
//    for (var i in localStorage) {
//        var aa = i;
//        var jsval = localStorage.getItem(aa);
//    }
//    var fileValue = window.atob(jsval);
//    var value = JSON.parse(fileValue);
//    //var elemHead = $('#configuration-monitoring div.f-configuration-monitoring__item label.f-checkbox input.f-checkbox__control');
//    //for (var i = 0; i < elemHead.length; i++) {
//    //    elemHead[i].checked = value.head[i];
//    //}
//    var elemBodyCheck = $('div.f-configuration-body div.row div.checkedcol table tbody tr td.has--checkbox input.f-checkbox__control');
//    for (var i = 0; i < elemBodyCheck.length; i++) {
//        elemBodyCheck[i].checked = value.check[i];
//        if (!value.check[i]) {
//            var hideTH = document.querySelectorAll('div.pamm-rates table.ratetable tr th[name=' + elemBodyCheck[i].name + ']');
//            for (var j = 0; j < hideTH.length; j++) {
//                hideTH[j].style.display = 'none';
//            }
//            var hideTD = document.querySelectorAll('div.pamm-rates table.ratetable tr td[name=' + elemBodyCheck[i].name + ']');
//            for (var j = 0; j < hideTD.length; j++) {
//                hideTD[j].style.display = 'none';
//            }
//        }
//    }
//    var elemBodyInput = $('div.f-configuration-body div.row div.checkedcol table tbody tr td.has--input input[type=text]');
//    for (var i = 0; i < elemBodyInput.length; i++) {
//        elemBodyInput[i].value = value.input[i];
//        changeInput(elemBodyInput[i].value, elemBodyInput[i].name);
//    }
//}

function url64data(encodedData) {
    var newUrl = document.location.href + '#settings=' + encodedData;
    document.getElementById('link').value = newUrl;
}

function valueformURL(data, fileName) {
    var fileValue = window.atob(data);
    localStorage.setItem(fileName, fileValue);
    //var elemHead = document.getElementById('configuration-monitoring');
    var value = JSON.parse(localStorage.getItem(fileName));
    //for (var i = 0; i < elemHead.children.length; i++) {
    //    elemHead.children[i].children[0].children[0].checked = value.head[i];
    //}
    var elemBodyCheck = document.querySelectorAll('div.f-configuration-body div.row div.checkedcol table tbody tr td.has--checkbox input.f-checkbox__control');
    for (var i = 0; i < elemBodyCheck.length; i++) {
        elemBodyCheck[i].checked = value.check[i];
        if (!value.check[i]) {
            var hideTH = document.querySelectorAll('div.pamm-rates table.ratetable tr th[name=' + elemBodyCheck[i].name + ']');
            for (var j = 0; j < hideTH.length; j++) {
                hideTH[j].style.display = 'none';
            }
            var hideTD = document.querySelectorAll('div.pamm-rates table.ratetable tr td[name=' + elemBodyCheck[i].name + ']');
            for (var j = 0; j < hideTD.length; j++) {
                hideTD[j].style.display = 'none';
            }
        }
    }
    var elemBodyInput = document.querySelectorAll('div.f-configuration-body div.row div.checkedcol table tbody tr td.has--input input[name]');
    for (var i = 0; i < elemBodyInput.length; i++) {
        elemBodyInput[i].value = value.input[i];
        changeInput(elemBodyInput[i].value, elemBodyInput[i].name);
    }
}

function triggerInput() {
    $('div.pamm-rates table.ratetable tr.filters input[name]').trigger('keyup');
}

function changeInput(value, key) {
    var elemsFilter = $('div.pamm-rates table.ratetable tr.filters td input[name=' + key + ']');
    for (var i = 0; i < elemsFilter.length; i++) {
        elemsFilter[i].value = value;
    }
}

function hidecell(valuetohide) {
    //if (valuetohide === 1) {
    //    var elems = $('div.pamm-rates table.ratetable tr td[name]', 'div.pamm-rates table.ratetable tr th[name]');
    //    elems.hide();
    //}
    for (var i in valuetohide) {
        var elemsHead = $('div.pamm-rates table.ratetable tr th[name=' + i + ']');
        if (i !== 'CreditAmount') valuetohide[i] ? elemsHead.show() : elemsHead.hide();
        var elems = $('div.pamm-rates table.ratetable tr td[name=' + i + ']');
        if (i !== 'CreditAmount') valuetohide[i] ? elems.show() : elems.hide();
    }
}

function checkhash() {
    if (window.location.hash.length > 50) {
        var a = window.location.hash;
        var reg = /#\w+\=(.*)$/i;
        var as = a.match(reg);
        var name = 'URL';
        valueformURL(as[1], name);
    }
}

var qoutesCache = {};
function updateQuotes(elem) {
    $.get(UrlApi + 'external/get-quotes', function (data) {
        var a = data;
        var q = [];
        q.push('<table class="f-table f-table--styled f-table--multiple f-table--selectable has--glass-top"><thead><tr><th>' + { ru: 'Инструмент', 'en-gb': 'Symbol' }[culture] + '</th><th>' + { ru: 'Продажа', 'en-gb': 'Sell' }[culture] + '</th><th>' + { ru: 'Покупка', 'en-gb': 'Buy' }[culture] + '</th><th>' + { ru: 'Спред', 'en-gb': 'Spread' }[culture] + '</th></tr></thead><tbody id="rates">');
        for (var i = 0; i < a.length; i++) {
            var symbol = a[i].Key;
            q.push('<tr><th>');
            q.push(symbol);
            q.push('</th><td class="has--numbers has--arrow">');
            var prev = qoutesCache.hasOwnProperty(symbol) ? qoutesCache[symbol] : (qoutesCache[symbol] = { v: a[i].Value, dAsk: 0, dBid: 0 });
            var d1 = Math.sign(a[i].Value.Bid - prev.v.Bid);
            prev.dBid = d1 ? d1 : prev.dBid;
            q.push((a[i].Value.Bid * Math.pow(10, a[i].Value.Exp))['formatNumber' + (-a[i].Value.Exp)]());
            q.push(prev.dBid ? (prev.dBid > 0 ? '<span class="f-trade-status f-trade-status--up"></span></td><td class="has--numbers has--arrow">' : '<span class="f-trade-status f-trade-status--down"></span></td><td class="has--numbers has--arrow">') : '</td><td class="has--numbers has--arrow">');
            var d2 = Math.sign(a[i].Value.Ask - prev.v.Ask);
            prev.dAsk = d2 ? d2 : prev.dAsk;
            q.push((a[i].Value.Ask * Math.pow(10, a[i].Value.Exp))['formatNumber' + (-a[i].Value.Exp)]());
            q.push(prev.dAsk ? (prev.dAsk > 0 ? '<span class="f-trade-status f-trade-status--up"></span></td><td class="has--numbers">' : '<span class="f-trade-status f-trade-status--down"></span></td><td class="has--numbers">') : '</td><td class="has--numbers">');
            q.push(((a[i].Value.Ask - a[i].Value.Bid) * 0.1).formatNumber1());
            q.push('</td></tr>');
            prev.v = a[i].Value;
        }
        q.push('</tbody></table>');
        elem.html(q.join(''));
    });
}

function initializeQuotesBlock() {
    var run = function () {
        updateQuotes(this);
        setTimeout(run, 2000);
    }.bind(this);

    setTimeout(run, 2000);
}

var globalData;
function getNewRates(elem) {
    $.ajax({
        url: UrlApi + 'external/get-all-quotes',
        type: 'GET',
        xhrFields: { withCredentials: false }
    }).done(function (x) {
        globalData = x;
        renderRates(globalData);
    });
}

var qoutesAllCache = {};
function renderRates(data) {
    var a = data;
    data.sort();
    elem = $('#quotesAll');
    var q = [];
    q.push('<table class="f-table f-table--styled f-table--multiple f-table--selectable"><thead><tr class="has--glass-both-c"><th>' + { ru: 'Инструмент', 'en-gb': 'Symbol' }[culture] + '</th><th style="text-align:right">' + { ru: 'Покупка', 'en-gb': 'Buy' }[culture] + '</th><th style="text-align:right">' + { ru: 'Продажа', 'en-gb': 'Sell' }[culture] + '</th><th>' + { ru: 'Спред', 'en-gb': 'Spread' }[culture] + '</th></tr></thead><tbody>');
    if (filter) {
        for (var sym in a) {
            if (filter.hasOwnProperty(a[sym].Key)) {
                var symbol = a[sym].Key;
                q.push('<tr><th>');
                q.push(symbol);
                q.push('</th><td class="has--numbers has--arrow">');
                var prev = qoutesAllCache.hasOwnProperty(symbol) ? qoutesAllCache[symbol] : (qoutesAllCache[symbol] = { v: a[sym].Value, dAsk: 0, dBid: 0 });
                var d1 = Math.sign(a[sym].Value.Bid - prev.v.Bid);
                prev.dBid = d1 ? d1 : prev.dBid;
                q.push((a[sym].Value.Bid * Math.pow(10, a[sym].Value.Exp))['formatNumber' + (-a[sym].Value.Exp)]());
                q.push(prev.dBid ? (prev.dBid > 0 ? '<span class="f-trade-status f-trade-status--up"></span></td><td class="has--numbers has--arrow">' : '<span class="f-trade-status f-trade-status--down"></span></td><td class="has--numbers has--arrow">') : '</td><td class="has--numbers has--arrow">');
                var d2 = Math.sign(a[sym].Value.Ask - prev.v.Ask);
                prev.dAsk = d2 ? d2 : prev.dAsk;
                q.push((a[sym].Value.Ask * Math.pow(10, a[sym].Value.Exp))['formatNumber' + (-a[sym].Value.Exp)]());
                q.push(prev.dAsk ? (prev.dAsk > 0 ? '<span class="f-trade-status f-trade-status--up"></span></td><td class="has--numbers">' : '<span class="f-trade-status f-trade-status--down"></span></td><td class="has--numbers">') : '</td><td class="has--numbers">');
                q.push(((a[sym].Value.Ask - a[sym].Value.Bid) * 0.1).formatNumber1());
                q.push('</td></tr>');
                prev.v = a[sym].Value;
            }
        }
    }
    q.push('</tbody></table>');
    elem.html(q.join(''));
}

function initializeAllQuotesBlock() {
    var run = function () {
        if ($('[name=updaterate]').prop('checked')) {
            getNewRates(this);
            updateDate();
        }
        setTimeout(run, 2000);
    }.bind(this);
    setTimeout(run, 2000);
}

function redrawRates(names) {
    filter = {};
    for (var i = 0; i < names.length; i++) {
        filter[names[i]] = null;
    }
}

rows = {};
var rates = {};
filter = null;
var swaparray = {};

function updateDate() {
    var myDate = DateTimeFormat.format(new Date());
    var elem = $('#updateTime');
    elem.text(myDate);
}

function init_rates() {
    updateDate();
}

var spreads = {};
function callspreadtable() {
    var from = new Date(Date.parse($('#fromid').val()));
    var to = new Date(Date.parse($('#toid').val()));
    if (to < from) {
        $('#hidden_allert').show();
        return;
    }
    $('#hidden_allert').hide();
    
    from.setMinutes(0-from.getTimezoneOffset());
    to.setMinutes(0-to.getTimezoneOffset());
    $.ajax({
        url: UrlApi + 'spreads',
        type: 'GET',
        data: { from: from.toJSON().slice(0,10), to: to.toJSON().slice(0,10) },
    }).done(function (a) {
        spreads = a;
        var elem = document.getElementById('spreadtable');
        var q = [];
        q.push('<table class="f-table f-table--styled f-table--multiple"><colgroup><col></col><col style="background-color:rgba(4, 80, 134, 0.1)"></colgroup><thead><tr class="has--glass-top-c"><th class="has--glass-top-c">' + { ru: 'Инструмент', 'en-gb': 'Symbol' }[culture] + '</th><th>' + { ru: 'Средний', 'en-gb': 'Average' }[culture] + '</th><th>' + { ru: 'Минимум', 'en-gb': 'Minimum' }[culture] + '</th><th>' + { ru: 'Максимум', 'en-gb': 'Maximum' }[culture] + '</th></tr></thead><tbody>');
        var b = Object.keys(spreads);
        var timeGlobal = globalNames;
        if ($('#ecn').prop("checked")) globalNames = b.filter(function (el) { return /\w+\.$/.test(el); });
        globalNames.sort();
        for (var i = 0; i < globalNames.length; i++) {
            var item = spreads[globalNames[i]];
            q.push('<tr><td>', globalNames[i]);
            q.push('</td>');
            q.push('<td class="has--numbers">');
            q.push(item && isFinite(item.avg) ? (item.avg * 0.1).formatNumber1() : '-');
            q.push('</td>');
            q.push('<td class="has--numbers">');
            q.push(item && isFinite(item.min) ? (item.min * 0.1).formatNumber1() : '-');
            q.push('</td>');
            q.push('<td class="has--numbers">');
            q.push(item && isFinite(item.max) ? (item.max * 0.1).formatNumber1() : '-');
            q.push('</td></tr>');
        }
        q.push('</tbody></table>');
        elem.innerHTML = q.join('');
        globalNames = timeGlobal;
    });
}

function updatespread(names) {
    names.sort();
    var elem = document.getElementById('spreadtable');
    var q = [];
    q.push('<table class="f-table f-table--styled f-table--multiple"><colgroup><col></col><col style="background-color:rgba(4, 80, 134, 0.1)"></colgroup><thead><tr class="has--glass-top-c"><th>' + { ru: 'Инструмент', 'en-gb': 'Symbol' }[culture] + '</th><th>' + { ru: 'Средний', 'en-gb': 'Average' }[culture] + '</th><th>' + { ru: 'Минимум', 'en-gb': 'Minimum' }[culture] + '</th><th>' + { ru: 'Максимум', 'en-gb': 'Maximum' }[culture] + '</th></tr></thead><tbody>');
    for (var i = 0; i < names.length; i++) {
        var item = spreads[names[i]];
        q.push('<tr><td>');
        q.push(names[i]);
        q.push('</td>');
        q.push('<td class="has--numbers">');
        q.push(item && isFinite(item.avg) ? (item.avg * 0.1).formatNumber1() : '-');
        q.push('</td>');
        q.push('<td class="has--numbers">');
        q.push(item && isFinite(item.min) ? (item.min * 0.1).formatNumber1() : '-');
        q.push('</td>');
        q.push('<td class="has--numbers">');
        q.push(item && isFinite(item.max) ? (item.max * 0.1).formatNumber1() : '-');
        q.push('</td></tr>');
    }
    q.push('</tbody></table>');
    elem.innerHTML = q.join('');
}

var globalNames;
function scheduleUpdate() {
    if (timerId) clearTimeout(timerId);
    var names = $('#SymbolFilterDialog input[data-group-item]:checked').map(function () {
        return this.name;
    });
    globalNames = names;
    timerId = setTimeout(function () {
        timerId = 0;
        if ($('#ecn').prop('checked')) {
            ecn_selector(true);
        } else ecn_selector(false);
    }, 1000);
}

var timerId = 0;
function init() {
    var searchMain = $('#SymbolFilterDialog #main input');
    for (var i = 0; i < searchMain.length; i++) {
        searchMain[i].checked = true;
    }
    scheduleUpdate();
    var st = {};
    var group_inputs = $('#SymbolFilterDialog input[data-group]');
    for (var i = 0; i < group_inputs.length; i++) {
        var gr = $(group_inputs[i]).attr('data-group');
        var sub_inputs = $('#SymbolFilterDialog input[data-group-item=' + gr + ']');
        var x = (st[gr] = { gr: group_inputs[i], items: sub_inputs, count: 0 });
        for (var j = 0; j < sub_inputs.length; j++) {
            if (sub_inputs[j].checked) x.count++;
        }
    }

    $(document).on('click', '#SymbolFilterDialog input', function () {
        var $this = $(this);
        var c = $this.prop('checked');
        var group = $this.attr('data-group-item');
        if (group) {
            var x = st[group];
            c ? x.count++ : x.count--;
            x.gr.indeterminate = x.count && x.count < x.items.length;
            x.gr.indeterminate || (x.gr.checked = x.count > 0);
            scheduleUpdate();
            return;
        }
        group = $this.attr('data-group');
        if (group) {
            var x = st[group];
            x.count = c ? x.items.length : 0;
            x.items.prop('checked', c);
            scheduleUpdate();
            return;
        }
    });

    $(document).on('click', '#accordion div.panel', function () {
        var notThis = $('div.panel');
        var notThisA = $('div.panel a');
        var notThisDiv = $('div.panel>div:last-child');
        for (var i = 0; i < notThis.length; i++) {
            if (notThis[i] == this) continue;
            $(notThisA[i]).attr('class', 'collapsed');
            $(notThisA[i]).prop('aria-expanded', false);
            $(notThisDiv[i]).prop('aria-expanded', false);
            $(notThisDiv[i]).attr('class', 'panel-collapse collapse');
        }
    });
}

function ecn_selector(val) {
    if (val) {
        var ecnNames = [];
        var inst_new = globalNames ? globalNames : spreads;
        for (var i = 0; i < inst_new.length; i++) {
            ecnNames[i] = inst_new[i];
            ecnNames[i] = ecnNames[i] + '.';
        }
        updatespread(ecnNames);
        redrawRates(ecnNames);
        var ecnSwapNames = [];
        var inst_swap_new = globalNames ? globalNames : swaparray;
        for (var i = 0; i < inst_swap_new.length; i++) {
            ecnSwapNames[i] = inst_swap_new[i];
            ecnSwapNames[i] = ecnSwapNames[i] + '.';
        }
        updateswaps(ecnSwapNames);
    } else {
        var ecnNames = [];
        var inst_new = globalNames ? globalNames : spreads;
        for (var i = 0; i < inst_new.length; i++) {
            ecnNames[i] = inst_new[i];
        }
        updatespread(ecnNames);
        redrawRates(ecnNames);
        var ecnSwapNames = [];
        var inst_swap_new = globalNames ? globalNames : swaparray;
        for (var i = 0; i < inst_swap_new.length; i++) {
            ecnSwapNames[i] = inst_swap_new[i];
        }
        updateswaps(ecnSwapNames);
    }
}

function callswaptable() {
    $.ajax({
        url: UrlApi + 'external/get-swaps',
        type: 'GET',
        //contentType: "application/json",
        xhrFields: { withCredentials: false }
        //context: $form
    }).done(function (x) {
        swaparray = x;
        var elem = document.getElementById('swaptable');
        var q = [];
        q.push('<table><tr><th>Name</th><th>Long</th><th>Short</th>');
        var c = Object.keys(x);
        var newNames = c.filter(function (el) {
            return !/\.$/.test(el);
        });
        for (var g in newNames) {
            var item = newNames[g];
            q.push('<tr><td>');
            q.push(g);
            q.push('</td>');
            q.push('<td class="has--numbers">');
            q.push(item && isFinite(item.Long) ? item.Long.formatNumber2() : '-');
            q.push('</td>');
            q.push('<td class="has--numbers">');
            q.push(item && isFinite(item.Short) ? item.Short.formatNumber2() : '-');
            q.push('</td></tr>');
        }
        q.push('</tbody></table>');
        elem.innerHTML = q.join('');
    });
}

function updateswaps(names) {
    names.sort();
    var elem = document.getElementById('swaptable');
    var q = [];
    q.push('<table class="f-table f-table--styled f-table--multiple"><thead><tr class="has--glass-top-c"><th>' + { ru: 'Инструмент', 'en-gb': 'Symbol' }[culture] + '</th><th>Long</th><th>Short</th></tr></thead><tbody>');
    for (var i = 0; i < names.length; i++) {
        var item = swaparray[names[i]];
        q.push('<tr><td>');
        q.push(names[i]);
        q.push('</td>');
        q.push('<td class="has--numbers">');
        q.push(item && isFinite(item.Long) ? item.Long.formatNumber2() : '-');
        q.push('</td>');
        q.push('<td class="has--numbers">');
        q.push(item && isFinite(item.Short) ? item.Short.formatNumber2() : '-');
        q.push('</td></tr>');
    }
    q.push('</tbody></table>');
    elem.innerHTML = q.join('');
}

function drawPartnerTable(a) {
    var p = a.Data;
    var elem = $('#partberTable');
    var q = [];
    q.push('<table><tr><th>' + { ru: '№', 'en-gb': 'No.', pt: 'Não.', es: 'No.' }[culture] + '</th><th style="text-align:left">' + { ru: 'Агент', 'en-gb': 'Agent', pt: 'Agente', es: 'Agente' }[culture] + '</th><th style="text-align:center;">' + { ru: 'Комиссионные отчисления', 'en-gb': 'Referral reward', pt: '&#8195;&#8195;&#8195;&nbsp;Comissões', es: 'Deducciones de comisiones' }[culture] + ', USD</th>');
    for (var i = 0; i < p.length; i++) {
        q.push('<tr><td><span>');
        q.push(i + 1);
        q.push('</span></td>');
        q.push('<td style="text-align:left;"><span>');
        q.push(p[i].Nickname);
        q.push('</span></td>');
        q.push('<td style="text-align:center;"><span>');
        q.push(p[i].Comission.formatNumber2());
        q.push('</span></td></tr>');
    }
    q.push('</tbody></table>');
    elem.html(q.join(''));
}

var partnerRatingData;
function getPartnerRates(elem) {
    $.ajax({
        url: UrlApi + 'external/partners-rating',
        type: 'GET',
        xhrFields: { withCredentials: false }
    }).done(function (x) {
        partnerRatingData = x;
        drawPartnerTable(partnerRatingData);
    });
}

var swapData, spreadData;

function initContracts() {
    specContracts();
    drawspecContracts();
}
function specContracts() {
    $.ajax({
        url: UrlApi + 'external/get-swaps',
        type: 'GET',
        xhrFields: { withCredentials: false }
    }).done(function (x) {
        swapData = x;
        doneContracts();
    });
}

function drawspecContracts() {
    $.ajax({
        url: UrlApi + 'spreads',
        type: 'GET',
        xhrFields: { withCredentials: false }
    }).done(function (y) {
        spreadData = y;
        var objectY = Object.keys(y);
        //for (var i = 0; i < objectY.length; i++) {
        //    var ReplaceData = [];
        //    ReplaceData[i] = objectY[i].replace(/(^\[)/, '').replace(/(])/, '');
        //    spreadData[ReplaceData[i]] = spreadData[objectY[i]];
        //    delete spreadData[objectY[i]];
        //}
        doneContracts();
    });
}
function doneContracts() {
    if (spreadData && swapData) return specContrselector(false);
    return false;
}

var sw, sp, dataPairs, instForSpecName;
function filterSymbol(el) { return /\.$/.test(el) == this; }

function filterSymbolUK(el, val) { return !/\.uk$/.test(el); }

function specContrselector(val) {
    sw = Object.keys(swapData);
    sw = sw.filter(filterSymbol.bind(val));
    sw = sw.filter(filterSymbolUK.bind(val));
    if (!spreadData.length && !instForSpecName) {
        instForSpecName = 'all';
    }
    if (instForSpecName) {
        dataPairs = instForSpec[instForSpecName].filter(filterSymbol.bind(val));
        dataPairs.sort();
        redrawSpecContr(sw, dataPairs);
    } else {
        sp = Object.keys(spreadData).filter(filterSymbolUK.bind(val));
        sp = sp.filter(filterSymbol.bind(val));
        sp.sort();
        redrawSpecContr(sw, sp);
    }
}

function redrawSpecContr(sw, sp) {
    var q = [];
    var c = Object.keys(swapData);
    var elem = document.getElementById('specContr');
    q.push('<table class="f-table f-table--styled inv-table-blue"><colgroup><col style="background-color: rgba(68, 146, 228, 0.1);" class="has--border-right"><col style="background-color: rgba(14, 98, 187, 0.05);"></colgroup><thead><tr><th class="has--border-right" rowspan="2">')
    q.push({ ru: 'Символ', 'en-gb': 'Symbol' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Название', 'en-gb': 'Name' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Минимальный<br>объем сделки,<br>лот', 'en-gb': 'Min<br>lot' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Максимальный<br>объем сделки,<br>лот', 'en-gb': 'Max<br>lot' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Шаг<br>объема<br>сделки', 'en-gb': 'Step<br>of the trade<br>volume' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Размер 1 лота<br>(единиц базовой<br>валюты)', 'en-gb': 'Value of 1 lot<br>(units of base<br>currency)' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Число<br>разрядов<br>котировки', 'en-gb': 'Digits' }[culture]);
    q.push('</th><th class="has--border-right" rowspan="2">');
    q.push({ ru: 'Средний<br>спред,<br>пп', 'en-gb': 'Average<br>spread' }[culture]);
    q.push('</th><th class="has--border-right has--shadow-bottom" colspan="2">Swap</th><th colspan="3" class="has--shadow-bottom">');
    q.push({ ru: 'Расписание торгов, ЕЕТ', 'en-gb': 'Schedule of trading, EET' }[culture]);
    q.push('</th></tr><tr><th>Long</th><th class="has--border-right">Short</th><th>');
    q.push({ ru: 'Открытие', 'en-gb': 'Open' }[culture]);
    q.push('</th><th class="has--border-right">');
    q.push({ ru: 'Закрытие', 'en-gb': 'Close' }[culture]);
    q.push('</th><th class="has--border-right">');
    q.push({ ru: 'Перерыв', 'en-gb': 'Market break' }[culture]);
    q.push('</th></tr></thead><tbody  class="has--border-top-4">');
    for (var i = 0; i < sp.length; i++) {
        if (!allDate[sp[i].split('.')[0]]) continue;
        var item = swapData[sp[i]];
        q.push('<tr class="has--shadow-bottom-c"><td>');
        q.push(sp[i]);
        q.push('</td><td>');
        q.push(allDate[sp[i].split('.')[0]]);
        q.push('</td><td>');
        q.push(minLotSymbols[sp[i].split('.')[0]] ? minLotSymbols[sp[i].split('.')[0]] : '0.01');
        q.push('</td><td>');
        q.push(maxLotSymbols[sp[i].split('.')[0]] ? maxLotSymbols[sp[i].split('.')[0]] : '1000');
        q.push('</td><td>');
        q.push(step[sp[i].split('.')[0]] ? step[sp[i].split('.')[0]] : '0.01');
        q.push('</td><td>');
        q.push(baseStep[sp[i].split('.')[0]] ? baseStep[sp[i].split('.')[0]] : '100 000');
        q.push('</td><td>');
        q.push(pairsSymbol[sp[i].split('.')[0]] ? pairsSymbol[sp[i].split('.')[0]] : '5');
        q.push('</td><td>');
        q.push(spreadData[sp[i]] && isFinite(spreadData[sp[i]].avg) ? (spreadData[sp[i]].avg * 0.1).formatNumber1() : '-');
        q.push('</td><td>');
        q.push(item && isFinite(item.Long) ? (item.Long * 0.1).formatNumber1() : '-');
        q.push('</td><td>');
        q.push(item && isFinite(item.Short) ? (item.Short * 0.1).formatNumber1() : '-');
        q.push('</td><td>');
        q.push(timeOpen[sp[i]] ? timeOpen[sp[i]] : '0:05:00');
        q.push({ ru: ' пн', 'en-gb': ' Mon' }[culture]);
        q.push('</td><td>');
        q.push(timeClose[sp[i]] ? timeClose[sp[i]] : '23:50:00');
        q.push(instForSpec.crypto.indexOf(sp[i].split('.')[0], 0) >= 0 ? { ru: ' Вск', 'en-gb': ' Sun' }[culture] : { ru: ' пт', 'en-gb': ' Fr' }[culture]);
        q.push('<td>');
        //q.push(instForSpec.crypto.indexOf(sp[i].split('.')[0], 0) >= 0 ? { ru: 'сб ', 'en-gb': 'St ' }[culture] : '');
        q.push(timeBreakDay[sp[i]] ? (timeBreakDay[sp[i]].split(',')[0] === "Tue-Thu " ? { ru: 'Вт-Чт ', 'en-gb': 'Tue-Thu ' }[culture] : { ru: 'Пт-Пн ', 'en-gb': 'Fri-Mon ' }[culture]) : '');
        q.push(timeBreak[sp[i]] ? timeBreak[sp[i]] : '-');
        q.push(timeBreakDay[sp[i]] ? (timeBreakDay[sp[i]].split(',')[1] === " Fri-Mon" ? { ru: ' Пт-Пн', 'en-gb': ' Fri-Mon' }[culture] : { ru: ' Вт-Чт', 'en-gb': ' Tue-Thu' }[culture]) : '');
        q.push('</td></td></tr>');
    }
    q.push('</tbody></table>');
    elem.innerHTML = q.join('');
}

function chooseData(el, name) {
    instForSpecName = name;
    var a = $('#apart').prop('checked') ? true : false;
    specContrselector(a);
    $(el)
        .addClass('active')
        .siblings('.active')
        .removeClass('active');
}

function genesisTableCreate() {
    $.ajax({
        url: UrlApi + 'external/genesis',
        type: 'GET',
        contentType: 'application/json',
        headers: {
            Accept: 'application/json'
        },
        xhrFields: { withCredentials: false }
    }).done(function (data) {
        var a = (data.ParticipantsG1 || []).concat(data.ParticipantsGP1 || []),
            b = (data.ParticipantsG2 || []).concat(data.ParticipantsGP2 || []),
            c = (data.ParticipantsG3 || []).concat(data.ParticipantsGP3 || []),
            d = (data.ParticipantsG4 || []).concat(data.ParticipantsGP4 || []),
            t = [
                a,
                b,
                c,
                d,
                data.Applicants && data.Applicants.filter(function (a) {
                    return a.Status == 'Rejected';
                }),
                data.Applicants && data.Applicants.filter(function (a) {
                    return a.Status == 'New';
                })
            ];
        var r = [];
        var l = 0;
        for (var i = 0; i < t.length; i++) t[i] && (l = Math.max(l, t[i].length));
        for (var i = 0; i < l; i++) {
            var _ = [];
            for (var j = 0; j < t.length; j++) _[j] = t[j] && i < t[j].length ? t[j][i] : null;
            r[i] = _;
        }
        var q = [];
        var elem = document.getElementById('genesisTable');
        q.push('<table class="f-table f-table--stages f-table--nowrap-content has--glass-top f-mb-32"><thead><tr><th></th> <th colspan="2" width="196"><h5>' + { ru: 'Этапы', 'en-gb': 'Stages', es: 'Etapas', pt: 'Etapas' }[culture] + '</h5> </th> <th width="112" class="has--border-right-4">' + { ru: 'Пополнение и <br>снятие средств', 'en-gb': 'Deposit and withdrawal of funds.', es: 'Depósito y retiro<br>de fondos', pt: 'Depósito e retirada de fundos' }[culture] + '</th> <th colspan="4" class="has--border-both-4 has--border-bottom"> <h5>' + { ru: 'Участники', 'en-gb': 'Participants', es: 'Participantes', pt: 'Participantes' }[culture] + '</h5> </th> <th colspan="2" class="has--border-left-4 has--border-bottom"> <h5>' + { ru: 'Соискатели на новый этап', 'en-gb': 'Applicants for a new stage', es: 'Candidatos de la nueva etapa', pt: 'Pretendentes de nova etapa' }[culture] + '</h5> </th> </tr></thead>');
        q.push('<tbody>');
        q.push('<tr> <th rowspan=' + (33 + l) + ' class="is--reversed"> <span>2019</span> </th> <td>' + { ru: '', 'en-gb': '', es: '', pt: 'Dia ' }[culture] + '1 ' + { ru: 'октября', 'en-gb': 'October', es: 'de octubre', pt: 'de outubro' }[culture] + '</td><td rowspan=' + (l + 2) + '>' + { ru: 'Основной <br>период', 'en-gb': 'Basic<br>period', es: 'Período principal', pt: 'Período principal' }[culture] + '</td><td rowspan=' + (l + 2) + ' class="has--border-right-4"> <i class="f-icon f-icon--cross"></i> </td><td class="has--border-left-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage', es: 'Etapa', pt: 'Etapa' }[culture] + ' I</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage', es: 'Etapa', pt: 'Etapa', es: 'Etapa', pt: 'Etapa' }[culture] + ' II</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage', es: 'Etapa', pt: 'Etapa' }[culture] + ' III</td><td class="has--border-right-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage', es: 'Etapa', pt: 'Etapa' }[culture] + ' IV</td><td class="has--border-left-4 f-cell--title">' + { ru: 'Отказ', 'en-gb': 'Rejection', es: 'Rechazo', pt: 'Indeferimento' }[culture] + '</td><td class="f-cell--title">' + { ru: 'На рассмотрении', 'en-gb': 'Under consideration', es: 'En revisión', pt: 'Em análise' }[culture] + '</td></tr>');
        var href = '/' + (culture || 'en') + '/investor/rating/';
        var templLink = function (v, q) {
            if (v) {
                q.push('<a href="' + href + v.Name + '">');
                q.push(v.Nickname + '  #' + v.AccountId);
                q.push('<a>');
            }
        }
        for (var i = 0; i < r.length; i++) {
            q.push('<tr><td></td><td class="has--border-left-4 has--link">');
            templLink(r[i][0], q);
            q.push('</td ><td class="has--link">');
            templLink(r[i][1], q);
            q.push('</td ><td class="has--link">');
            templLink(r[i][2], q);
            q.push('</td ><td class="has--border-right-4 has--link">');
            templLink(r[i][3], q);
            q.push('</td ><td class="has--border-left-4">');
            q.push(r[i][4] ? r[i][4].Email : '');
            q.push('</td ><td>');
            q.push(r[i][5] ? r[i][5].Email : '');
            q.push('</td></tr>');
        }

        q.push('<tr> <td>22 ' + { ru: 'декабря', 'en-gb': 'December', es: 'de diciembre', pt: 'de dezembro' }[culture] + '</td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td style="text-align: center;">23&ndash;31<br>' + { ru: 'декабря', 'en-gb': 'December', es: 'de diciembre', pt: 'de dezembro' }[culture] + '</td><td rowspan="1">' + { ru: 'Переходный <br>период', 'en-gb': 'Transition <br>period', es: 'Período de transición', pt: 'O período transitório' }[culture] + '</td><td rowspan="1" class="has--border-right-4"> <i class="f-icon f-icon--check"></i> </td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr>');
        //q.push('<tr> <td>21 ' + { ru: 'сентября', 'en-gb': 'September', es: 'de septiembre', pt: 'de setembro' }[culture] + '</td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td style="text-align: center;">23&ndash;30<br>' + { ru: 'сентября', 'en-gb': 'September', es: 'de septiembre', pt: 'de setembro' }[culture] + '</td><td rowspan="1">' + { ru: 'Переходный <br>период', 'en-gb': 'Transition <br>period', es: 'Período de transición', pt: 'O período transitório' }[culture] + '</td><td rowspan="1" class="has--border-right-4"> <i class="f-icon f-icon--check"></i> </td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr>');
        //q.push('<tr> <td>2 апреля</td><td rowspan="8">Основной <br>период</td><td rowspan="8" class="has--border-right-4"> <i class="f-icon f-icon--cross"></i> </td><td class="has--border-left-4 f-cell--title">Этап I</td><td class="f-cell--title">Этап II</td><td class="f-cell--title">Этап III</td><td class="has--border-right-4 f-cell--title">Этап IV</td><td class="has--border-left-4 f-cell--title">Отказ</td><td class="f-cell--title">На рассмотрении</td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>23 июня</td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>30 июня</td><td rowspan="1">Переходный <br>период</td><td rowspan="1" class="has--border-right-4"> <i class="f-icon f-icon--check"></i> </td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr class="f-table__spacer"> <td colspan="3" class="has--border-right-4"></td><td colspan="4" class="has--border-left-4 has--border-right-4"></td><td colspan="2" class="has--border-left-4"></td></tr>');
        //q.push('<tr> <td>2 ' + { ru: 'июля', 'en-gb': 'July' }[culture] + '</td><td rowspan="8">' + { ru: 'Основной <br>период', 'en-gb': 'Basic<br>period' }[culture] + '</td><td rowspan="8" class="has--border-right-4"> <i class="f-icon f-icon--cross"></i> </td><td class="has--border-left-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' I</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' II</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' III</td><td class="has--border-right-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' IV</td><td class="has--border-left-4 f-cell--title">' + { ru: 'Отказ', 'en-gb': 'Rejection' }[culture] + '</td><td class="f-cell--title">' + { ru: 'На рассмотрении', 'en-gb': 'Under consideration' }[culture] + '</td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>23 ' + { ru: 'сентября', 'en-gb': 'September' }[culture] + '</td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>29 ' + { ru: 'сентября', 'en-gb': 'September' }[culture] + '</td><td rowspan="1">' + { ru: 'Переходный <br>период', 'en-gb': 'Transition <br>period' }[culture] + '</td><td rowspan="1" class="has--border-right-4"> <i class="f-icon f-icon--check"></i> </td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr class="f-table__spacer"> <td colspan="3" class="has--border-right-4"></td><td colspan="4" class="has--border-left-4 has--border-right-4"></td><td colspan="2" class="has--border-left-4"></td></tr>');
        // q.push('<tr> <td>30 ' + { ru: 'сентября', 'en-gb': 'September' }[culture] + '</td><td rowspan="8">' + { ru: 'Основной <br>период', 'en-gb': 'Basic <br>period' }[culture] + '</td><td rowspan="8" class="has--border-right-4"> <i class="f-icon f-icon--cross"></i> </td><td class="has--border-left-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' I</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' II</td><td class="f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' III</td><td class="has--border-right-4 f-cell--title">' + { ru: 'Этап', 'en-gb': 'Stage' }[culture] + ' IV</td><td class="has--border-left-4 f-cell--title">' + { ru: 'Отказ', 'en-gb': 'Rejection' }[culture] + '</td><td class="f-cell--title">' + { ru: 'На рассмотрении', 'en-gb': 'Under consideration' }[culture] + '</td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td></td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>21 ' + { ru: 'декабря', 'en-gb': 'December' }[culture] + '</td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr><tr> <td>28 ' + { ru: 'декабря', 'en-gb': 'December' }[culture] + '</td><td rowspan="1">' + { ru: 'Переходный <br>период', 'en-gb': 'Transition <br>period' }[culture] + '</td><td rowspan="1" class="has--border-right-4"> <i class="f-icon f-icon--check"></i> </td><td class="has--border-left-4"></td><td></td><td></td><td class="has--border-right-4"></td><td class="has--border-left-4"></td><td></td></tr>');
        q.push('</tbody></table>');
        elem.innerHTML = q.join('');
    });
}
